import React from 'react';
import { Reveal } from './Reveal';

export const Roadmap = () => {
  const items = [
    { q: 'Q2 … NOW', title: 'V1 launch', body: 'Marketplace + Builder + SSE chat + Stripe.', state: 'shipped', color: '#39FF14' },
    { q: 'Q3', title: 'Team workspaces', body: 'Shared agents, role-based access, audit logs.', state: 'next', color: '#FF6B1A' },
    { q: 'Q3', title: 'Programmatic API', body: 'API keys for Pro+; embed RevCore agents anywhere.', state: 'next', color: '#FF6B1A' },
    { q: 'Q4', title: 'Agent versioning + evals', body: 'Diff agents, A/B test prompts, score outputs.', state: 'queued', color: '#FFB17A' },
    { q: 'Q4', title: 'Private models + SSO', body: 'Enterprise SSO/SAML; bring-your-own model.', state: 'queued', color: '#FFB17A' },
  ];
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-16">
      <div className="flex items-end justify-between gap-3 mb-6 flex-wrap">
        <div>
          <span className="text-[10px] uppercase tracking-[0.22em] text-[#39FF14]">// roadmap</span>
          <h2 className="display text-2xl md:text-3xl font-semibold mt-1">What we ship next.</h2>
        </div>
        <span className="text-[11px] text-white/40 mono">public commit log</span>
      </div>
      <Reveal>
        <ol className="relative border-l border-border/60 ml-2 space-y-6">
          {items.map((it) => (
            <li key={`roadmap-${it.q}-${it.title}`} className="pl-5 relative">
              <span className="absolute -left-[7px] top-1 h-3 w-3 rounded-full" style={{ background: it.color, boxShadow: `0 0 12px ${it.color}` }} />
              <div className="flex items-center gap-3 flex-wrap">
                <span className="mono text-[10px] uppercase tracking-widest text-white/45">{it.q}</span>
                <span className="display font-semibold">{it.title}</span>
                <span className="text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full hairline" style={{ color: it.color }}>
                  {it.state}
                </span>
              </div>
              <p className="text-sm text-white/65 mt-1">{it.body}</p>
            </li>
          ))}
        </ol>
      </Reveal>
    </section>
  );
};
